module.exports = __webpack_public_path__ + "img/llyn.65f7a286.png";